export const light = {
    body:"#58C0BA",
    text: "white",
    bodyRgba : "255, 255, 255",
    bodyRgba2 : "255, 255, 255",
    textRgba:"255,255,255",
    textRgba2:"0, 0, 0",

    carouselColor: '#EEEDDE',
    fontxxs:'0.70em',
    fontxs:'0.75em',
    fontsm:'0.875em',
    fontmd:'1em', // 1em = 16px
    fontlg:'1.25em',
    fontxl:'2em',
    fontxxl:'3em',
    fontxxxl:'4em',

    fontButton:'0.875em',


    navHeight: '8rem',

}

export const dark = {
    body:"white",
    text:"white",
    bodyRgba : "32,32,32",
    textRgba:"255, 255, 255",

    carouselColor: '#EEEDDE',

    fontxs:'0.75em',
    fontsm:'0.875em',
    fontmd:'1em', // 1em = 16px
    fontlg:'1.25em',
    fontxl:'2em',
    fontxxl:'3em',
    fontxxxl:'4em',

    fontButton:'0.875em',


    navHeight: '5rem',

}